import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Wallet } from 'lucide-react';
export function Slide04Opportunity() {
  return <div className="w-full h-full flex flex-col justify-center px-[clamp(4rem,8vw,10rem)]" data-id="element-104">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-16 text-center" data-id="element-105">
        <span className="text-[var(--accent)] font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-106">
          Opportunity Sizing
        </span>
        <h2 className="font-display text-[clamp(2.5rem,4vw,4rem)] leading-tight" data-id="element-107">
          The cost of inaction is high.
        </h2>
      </motion.div>

      <div className="flex flex-col md:flex-row gap-8 max-w-6xl mx-auto w-full" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="flex-1 bg-[var(--fg)] text-[var(--bg)] p-10 rounded-[2.5rem] relative overflow-hidden" data-id="element-109">
          <div className="absolute top-0 right-0 p-8 opacity-20" data-id="element-110">
            <Users size={120} strokeWidth={1} data-id="element-111" />
          </div>
          <div className="relative z-10" data-id="element-112">
            <h3 className="font-display text-6xl mb-4 text-[var(--surface-alt)]" data-id="element-113">
              15%
            </h3>
            <p className="text-xl opacity-90 font-medium mb-2" data-id="element-114">
              Lift in Retention
            </p>
            <p className="opacity-70 leading-relaxed" data-id="element-115">
              Estimated impact of removing the weekly selection friction for our
              core demographic.
            </p>
          </div>
        </motion.div>

        <div className="flex-1 flex flex-col gap-8" data-id="element-116">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="flex-1 bg-[var(--surface)] p-8 rounded-[2.5rem] border border-[var(--surface-alt)] flex items-center gap-6" data-id="element-117">
            <div className="w-16 h-16 rounded-2xl bg-[var(--surface-alt)] flex items-center justify-center shrink-0" data-id="element-118">
              <TrendingUp className="text-[var(--fg)]" size={32} data-id="element-119" />
            </div>
            <div data-id="element-120">
              <h4 className="font-display text-3xl mb-1 text-[var(--accent)]" data-id="element-121">
                +$2.4M
              </h4>
              <p className="text-[var(--fg-muted)]" data-id="element-122">
                Projected ARR impact from saved churn
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="flex-1 bg-[var(--surface)] p-8 rounded-[2.5rem] border border-[var(--surface-alt)] flex items-center gap-6" data-id="element-123">
            <div className="w-16 h-16 rounded-2xl bg-[var(--surface-alt)] flex items-center justify-center shrink-0" data-id="element-124">
              <Wallet className="text-[var(--fg)]" size={32} data-id="element-125" />
            </div>
            <div data-id="element-126">
              <h4 className="font-display text-3xl mb-1 text-[var(--accent)]" data-id="element-127">
                +12%
              </h4>
              <p className="text-[var(--fg-muted)]" data-id="element-128">
                Increase in AOV via smart add-ons
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}